import React from 'react';
import Footer from '../components/Footer';
import { motion } from 'framer-motion';

const SeniorHigh = () => {
  return (
    <>
      <div className='p-5 lg:p-12 bg-waves bg-cover lg:px-36 min-h-screen space-y-3 lg:grid grid-cols-2'>
        <div>
          <motion.div
            animate={{ x: 0 }}
            initial={{ x: -500 }}
            transition={{ delay: 0.1 }}
          >
            <h3 className='text-black mb-4 text-4xl font-bold lg:text-left md:text-center lg:pl-12'>
              Senior High
            </h3>
          </motion.div>
          <div className='lg:py-4 lg:pr-12'>
            <div className='bg-white p-6 rounded-lg shadow-lg text-left flex-col max-w-fit'>
              <div>
                <p className='text-black sm:text-justify md:text-xl'>
                  Senior High School students in grades 10 to 12: Customized
                  teaching and support is provided for students looking to
                  master the fundamentals and excel in all grades 10 to 12
                  courses including:
                </p>
              </div>
              <div>
                <ol className='list-decimal sm:text-justify pl-12 text-left md:text-xl mt-3'>
                  <li>English 30-1 and 30-2</li>
                  <li>Social Studies 30-1 and 30-2</li>
                  <li>Mathematics 20-1, 20-2 and 20-3</li>
                  <li>Science 20 and 24</li>
                  <li>Biology 20, Chemistry 20 and Physics 20</li>
                  <li>Math 30, Biology 30, Chemistry 30, and Physics 30</li>
                  <li>Career and Life Management</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <div className='lg:pr-12'>
          <img
            className='sm:mx-auto h-auto rounded-3xl drop-shadow-2xl 2xl:mt-9 lg:mt-24'
            src='/senior.png'
            alt=''
          />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default SeniorHigh;
